export default "__VITE_ASSET__CbfelZQ5__"